// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__B8Pm8","heroContainer":"Hero_heroContainer__t8vk3"};